<template>
  <div class="blog-page">
    <section class="section section--filters" v-if="currentUser">
      <div class="container">
        <div class="section__head">
          <h2>Blog</h2>
        </div>

        <div class="search-entry">
          <input type="text" placeholder="Szukany post" id="searchText" v-model="searchText" required>

          <select name="entryCategory" id="entryCategory" v-model="entryCategory" required @change="getBlogPosts">
            <option value="">-- wybierz kategorię --</option>
            <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.title }}</option>
          </select>

          <select name="entryTarget" id="entryTarget" v-model="entryTarget" required @change="getBlogPosts">
            <option value="do wszystkich">do wszystkich</option>
            <option value="do specjalistów">do specjalistów</option>
            <option value="do właścicieli zwierząt">do właścicieli zwierząt</option>
          </select>

          <button class="filter-btn filter-btn--primary" @click="searchEntry">Szukaj</button>
          <button
            class="filter-btn"
            @click="() => {
              getBlogPosts()
              searchText = ''
              entryCategory = ''
              hidePages = false
              showLatestBlogEntries = true
            }">
            Resetuj
          </button>
        </div>
      </div>
    </section>

    <section class="section section--content" v-if="currentUser">
      <div class="container">
        <div class="entries-block" v-if="popularBlogPosts.length > 0">
          <div class="section__head section__head--toggle">
            <h2>Popularne wpisy</h2>
            <button class="toggle-btn" @click="() => showPopularBlogEntries = ! showPopularBlogEntries">
              <img :class="! showPopularBlogEntries ? 'closed' : null" src="@/assets/message-arrow.png" alt="Przełącz sekcję">
            </button>
          </div>

          <div class="cards-grid" v-if="showPopularBlogEntries">
            <BlogPostCardVue
              :id="post.id"
              :target="post.target"
              :title="post.title"
              :author="post.author"
              :photo="post.photo_url"
              :key="post.id"
              :created_at="post.created_at"
              v-for="post in popularBlogPosts"
            />
          </div>
        </div>

        <div class="entries-block" v-if="latestBlogPosts.length > 0">
          <div class="section__head section__head--toggle">
            <h2>Najnowsze wpisy</h2>
          </div>

          <div class="cards-grid">
            <BlogPostCardVue
              :id="post.id"
              :target="post.target"
              :title="post.title"
              :author="post.author"
              :photo="post.photo_url"
              :key="post.id"
              :created_at="post.created_at"
              v-for="post in latestBlogPosts"
            />
          </div>
        </div>

        <div class="blog-page" v-if="! hidePages">
          <div class="blog-pagination">
            <button class="blog-pagination__arrow" @click="() => {
              if (page > 1) {
                page -= 1;
                getBlogPosts();
              }
            }" :disabled="page <= totalPages">‹</button>
            <span>{{ page }} / {{ totalPages }}</span>
            <button class="blog-pagination__arrow" @click="() => {
              if (page < totalPages) {
                page += 1;
                getBlogPosts();
              }
            }" :disabled="page >= totalPages">›</button>
          </div>
        </div>

        <div class="cards-grid cards-grid--main" v-if="blogPosts.length > 0">
          <BlogPostCardVue
            :id="post.id"
            :target="post.target"
            :title="post.title"
            :author="post.author"
            :photo="post.photo_url"
            :key="post.id"
            :created_at="post.created_at"
            v-for="post in blogPosts"
          />
        </div>
        <div v-else class="empty-state">
          <div class="empty-state__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="img" focusable="false">
              <path d="M10 4h8a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h2zm0 2H8a2 2 0 0 0-2 2v8a2 2 0 1 0 4 0V6zm3 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2zm0 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2z"/>
            </svg>
          </div>
          <h3>Brak postów blogowych</h3>
          <p>Spróbuj zmienić filtry lub wpisz inną frazę wyszukiwania.</p>
        </div>
      </div>
    </section>

    <section class="section" v-else>
      <div class="container">
        <div class="not-logged-in">
          <h2>Zaloguj się, aby skorzystać z bloga</h2>
          <div>
            <ButtonVue text="Zaloguj się" bg-color="#10b981" color="#fff" @click="() => $router.push('/login')" />
            <ButtonVue text="Zarejestruj się" bg-color="#10b981" color="#fff" @click="() => $router.push('/register')" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ButtonVue from '@/components/Button.vue'
import { useMeta } from 'vue-meta'
import BlogPostCardVue from '@/components/SpecialComponents/BlogPostCard.vue'
import axios from 'axios'
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import { useCancelableRequests } from "@/services/request";

export default{
  name:'BlogVue',
  setup () {
    useMeta({
      title: 'Blog',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data () {
    return {
      entryTarget: localStorage.getItem('m2vetEntryMode') || 'do wszystkich',
      blogPosts: [],
      categories: [],
      selectedCategory: '',
      page: 1,
      totalPages: 1,
      entriesCount: null,
      entriesFound: [],
      entryCategory: '',
      searchText: '',
      hidePages: false,
      latestBlogPosts: [],
      showLatestBlogEntries: true,
      showPopularBlogEntries: true,
      popularBlogPosts: [],
      api: null
    }
  },
  computed: {
    currentUser () {
      return true;
    }
  },
  created () {
    this.api = useCancelableRequests();
    this.getBlogPosts();
    this.getCategories();
    this.getLatestEntries();
    this.getPopularBlogPosts();
  },
  components: { ButtonVue, BlogPostCardVue },
  methods:{
    getBlogPosts() {
      axios.get(`/GetBlogPostsByTarget/${this.entryTarget}/${this.page}`).then(res => {
        this.blogPosts = res.data
      }).catch(() => {
        console.log('Error fetching blog posts');
      })
    },
    getCategories(){
      axios.post('/BlogCategorySearch', {
        page: 1,
        limit: 1000
      }).then(res => {
        if(res.data.count > 1000){
          axios.post('/BlogCategorySearch', {
            page: 1,
            limit: res.data.count
          }).then(resp => {
            this.categories = resp.data.items
          })
        }else{
          this.categories = res.data.items
        }
      })
    },
    searchEntry(){
      this.hidePages = true
      this.showLatestBlogEntries = false
      if(this.searchText.length > 2 || this.entryCategory || this.entryTarget){
        axios.post('/BlogPostSearch', {
          page: 1,
          limit: 1000,
          blog_category_id: this.entryCategory
        }).then(res => {
          if(res.data.count > 1000){
            axios.post('/BlogPostSearch', {
              page: 1,
              limit: res.data.count,
              blog_category_id: this.entryCategory
            }).then(resp => {
              this.blogPosts = resp.data.items.filter(item => item.title.toLowerCase().includes(this.searchText.toLowerCase()) && item.target === this.entryTarget)
            })
          }else{
            this.blogPosts = res.data.items.filter(item => item.title.toLowerCase().includes(this.searchText.toLowerCase()) && item.target === this.entryTarget)
          }
        })
      }else{
        this.appStore.setIsAlert('wpisz co najmniej 3 litery')
      }
    },
    getLatestEntries () {
      this.api.request('latestBlogPosts', { url: `/GetLatestBlogPosts/${this.entryTarget}`, method: 'get' }).then(res => {
        this.latestBlogPosts = res?.data;
      });
    },
    getPopularBlogPosts(){
      this.popularBlogPosts = []
      axios.post('/BlogPostSearch', {
        page: 1,
        limit: 3,
        popular: true
      }).then(res => {
        res.data.items.forEach((post) => {
          const ob = {
            title: post.title,
            photo_url: post.photo_url,
            author: post.author,
            id: post.id,
            target: post.target,
            created_at: post.created_at
          }
          this.popularBlogPosts.push(ob)
        })
      }).catch(() => {

      })
    }
  },
}
</script>

<style scoped lang='scss'>
.blog-page {
  background: #f9fafb;
  color: #1f2937;
}

.container {
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.section {
  padding: 40px 0;
}

.section--filters {
  padding-bottom: 20px;
}

.section--content {
  padding-top: 20px;
}

.section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.section__head h2 {
  margin: 0;
}

.section__head--toggle {
  margin-bottom: 16px;
}

.search-entry {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto auto;
  gap: 12px;
  padding: 16px;
  align-items: stretch;
}

.search-entry input,
.search-entry select {
  padding: 2px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background-color: #fff;
  color: #1f2937;
  min-height: 42px;
}

.filter-btn {
  cursor: pointer;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-weight: 600;
}

.filter-btn--primary {
  background: #10b981;
  color: #fff;
  border-color: #10b981;
}

.filter-btn:hover {
  border-color: #10b981;
}

.toggle-btn {
  background: #fff;
  border: 1px solid #d1d5db;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn img {
  transform: rotate(-90deg);
  width: 16px;
  height: 16px;
}

.toggle-btn img.closed {
  transform: rotate(90deg);
}

.entries-block {
  margin-bottom: 28px;
}

.cards-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cards-grid--main {
  margin-top: 8px;
}

.entry-page {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin: 24px 0;
}

.entry-page--bottom {
  margin: 28px 0 8px;
}

.blog-pagination{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 16px 0 22px;
  &__arrow{
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 8px;
    background: #10b981;
    color: #fff;
    cursor: pointer;
    font-size: 2rem;
    line-height: 1;
  }
  &__arrow:disabled{
    opacity: .4;
    cursor: not-allowed;
  }
}

.not-logged-in {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.not-logged-in h2 {
  margin: 0;
}

.not-logged-in div {
  display: flex;
  justify-content: center;
  gap: 16px;
}

@media (max-width: 1024px) {
  .search-entry {
    grid-template-columns: 1fr 1fr;
  }

  .search-entry input {
    grid-column: 1 / -1;
  }

  .cards-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .section {
    padding: 28px 0;
  }

  .search-entry {
    grid-template-columns: 1fr;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .not-logged-in div {
    flex-direction: column;
    width: 100%;
  }
}
.empty-state {
  margin: 16px 0 8px;
  min-height: 320px;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  color: #6b7280;
  padding: 24px;
}

.empty-state__icon {
  width: 74px;
  height: 74px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #10b981;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.12);
}

.empty-state__icon svg {
  width: 38px;
  height: 38px;
  fill: currentColor;
}

.empty-state h3 {
  margin: 4px 0 0;
  color: #374151;
}

.empty-state p {
  margin: 0;
  max-width: 420px;
  font-size: 1.25rem;
}
</style>